import React from 'react';
import { Box, Link, Step, StepContent, StepLabel, Theme, Typography } from '@mui/material';
import { Link as RRLink } from 'react-router-dom';
import { Routes } from 'routing';
import moment from 'moment-timezone';
import { RiExternalLinkLine } from 'react-icons/ri';
import { useTranslation } from 'services/localization';
import { createStyles, makeStyles } from '@mui/styles';

interface Props {
	orderId: string;
	customerName: string | undefined;
	endDate: string | null;
	orderNumber: number | undefined;
	lastStep: boolean;
	active?: boolean;
}
const UsageHistoryStep = (props: Props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const { orderId, customerName, endDate, orderNumber, lastStep, active } = props;

	return (
		<Step expanded={true} last={lastStep}>
			<StepLabel
				StepIconComponent={active ? StepperIconActive : StepperIcon}
				sx={{ paddingY: 0.5, paddingX: 0 }}
				classes={{
					iconContainer: classes.iconContainer,
				}}
			>
				<Box display="flex">
					<Link
						component={RRLink}
						to={Routes.BookingPage(orderId)}
						underline="hover"
						sx={{ display: 'inline-flex', alignItems: 'center' }}
						target="_blank"
						rel="noopener noreferrer"
					>
						<span>{customerName ?? orderNumber ?? orderId}</span>
					</Link>
					<Box ml={0.5} display="flex" alignItems="center" sx={{ color: 'secondary' }}>
						<RiExternalLinkLine size={12} />
					</Box>
				</Box>
			</StepLabel>
			<StepContent
				sx={{
					paddingBottom: 2,
					paddingLeft: '18px',
					marginLeft: '4px',
					borderLeft: (theme) => `2px solid ${theme.palette.border.paper}`,
				}}
				classes={{
					last: classes.lastStep,
				}}
			>
				<Typography variant="body2" color="textSecondary" sx={{ fontSize: 13, fontWeight: 400 }}>
					{!!active
						? t('inventory.article.active', 'Active')
						: !endDate
						? ''
						: moment(endDate).format('ddd. MMM DD, YYYY')}
				</Typography>
			</StepContent>
		</Step>
	);
};

const StepperIconActive = () => {
	return <StepperIconBase active={true} />;
};

const StepperIcon = () => {
	return <StepperIconBase />;
};

const StepperIconBase = ({ active }: { active?: boolean }) => {
	return (
		<Box
			sx={{
				width: '10px',
				height: '10px',
				borderRadius: '100%',
				border: active ? 'none' : '1px solid black',
				backgroundColor: (theme) => (active ? theme.palette.success.light : 'none'),
			}}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		lastStep: {
			borderColor: 'transparent',
		},
		iconContainer: {
			paddingRight: '13px',
		},
	}),
);

export default UsageHistoryStep;
